import { IType } from '../internal';

export const string: IType = {
  name: 'string',
};
